// src/services/apiEndpoints.js
const API_BASE_URL = "https://api.ourchurchlink.com/";

export const API_ENDPOINTS = {
  // Users & Roles
  CHURCHES: `${API_BASE_URL}churches`,
  USER_ROLES: `${API_BASE_URL}user-roles`,
  ADMIN_ROLES: `${API_BASE_URL}admin-roles`,
  USERS: `${API_BASE_URL}users`,
  MEMBERS: `${API_BASE_URL}members`,

  // Main Features
  CALENDAR: `${API_BASE_URL}calendar`,
  EVENT_REQUESTS: `${API_BASE_URL}event-requests`,
  PRAYER_REQUESTS_ADMIN: `${API_BASE_URL}prayer-requests/admin`,
  PRAYER_ADMIN_COMMENTS: `${API_BASE_URL}adminCommentsForPrayer`,
  TESTIMONIES: `${API_BASE_URL}testimonies/admin`,
  TESTIMONY_ADMIN_COMMENTS: `${API_BASE_URL}adminCommentsForTestimony`,
  VOLUNTEERING_FORMS: `${API_BASE_URL}volunteers/admin`,
  DONATIONS_ADMIN: `${API_BASE_URL}donations/admin`,

  // Content Management
  AUDIO_FILES: `${API_BASE_URL}audio`,
  BIBLE_VERSIONS: `${API_BASE_URL}bible`,
  BIBLE_VERSION_UPDATE: (versionId) => `${API_BASE_URL}bible/${versionId}`,
  BIBLE_PRESIGNED: (versionId) => `${API_BASE_URL}bible/presigned/${versionId}`,
  DEVOTION: `${API_BASE_URL}devotion`,
  DOCUMENTS: `${API_BASE_URL}documents`,
  PODCASTS: `${API_BASE_URL}podcast`,
  MOTIVATION: `${API_BASE_URL}quotes`,
  VERSE_OF_THE_DAY: `${API_BASE_URL}verses`,

  // Utilites
  FILE_STORAGE: `${API_BASE_URL}file-storage`,
  NOTIFICATIONS: `${API_BASE_URL}/notifications`,
  SEND_NOTIFICATIONS: `${API_BASE_URL}/notifications`, // POST (e.g. member details notify) — same base as NOTIFICATIONS
  ADMIN_NOTIFICATIONS: "https://1yjbgnpkyc.execute-api.us-east-1.amazonaws.com/prod/admin/notifications",
  MEMBER_UPDATES: "https://1yjbgnpkyc.execute-api.us-east-1.amazonaws.com/prod/admin/member-updates",

  // Settings
  SETTINGS: `${API_BASE_URL}admin-panel-settings`,
  SETTINGS_PROFILE: `${API_BASE_URL}admin-panel-settings/profile`,
  SETTINGS_PROFILE_LOGO_PRESIGNED: `${API_BASE_URL}admin-panel-settings/profile/logo/presigned`,
  //YouTube Settings
  YOUTUBE_SETTINGS: `${API_BASE_URL}youtube-settings`,
  YOUTUBE_SETTINGS_CREDENTIALS: `${API_BASE_URL}youtube-settings/credentials`,
  YOUTUBE_SETTINGS_PLAYLISTS: `${API_BASE_URL}youtube-settings/playlists`,
  YOUTUBE_SETTINGS_LIVESTREAMS: `${API_BASE_URL}youtube-settings/livestreams`,
  YOUTUBE_SETTINGS_BACKFILL: `${API_BASE_URL}youtube-settings/backfill`
};

export default API_ENDPOINTS;
